var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lightroom_40",
    "data-name": "Lightroom 40",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_99544",
    "data-name": "Path 99544",
    d: "M7.125,0H33a7.005,7.005,0,0,1,7,7.1V31.9A7.11,7.11,0,0,1,32.875,39H7.125A7.11,7.11,0,0,1,0,31.9V7.1A7.032,7.032,0,0,1,7.125,0Z",
    fill: "#001e36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99545",
    "data-name": "Path 99545",
    d: "M18.975,25.625H8.35a.269.269,0,0,1-.25-.25V8.25A.269.269,0,0,1,8.35,8H11.6l.25.125h0v14H19.6a.269.269,0,0,1,.25.25l-.625,3L19.1,25.5Z",
    transform: "translate(2.025 1.942)",
    fill: "#31a8ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99546",
    "data-name": "Path 99546",
    d: "M18.925,11.45H21.8c.125,0,.25.125.375.25a.459.459,0,0,1,.125.375c0,.125.125.375.125.5V13.2a4.5,4.5,0,0,1,1.75-1.375,5.69,5.69,0,0,1,2.5-.625.436.436,0,0,1,.25.125h0V14.7a.269.269,0,0,1-.25.25,5.431,5.431,0,0,0-3.125.625,2.242,2.242,0,0,0-.875.625v8.5a.269.269,0,0,1-.25.25h-3.25a.269.269,0,0,1-.25-.25V12.825A3.461,3.461,0,0,0,18.8,11.7l.125-.25Z",
    transform: "translate(4.7 2.731)",
    fill: "#31a8ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightroom);
export default __webpack_public_path__ + "static/media/lightroom.c29588e2284e5b2b2b933c6ed3b44c62.svg";
export { ForwardRef as ReactComponent };